import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function Hamburger({ className }) {
	return (
		<svg className={classnames('svg', 'hamburger', className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14" width="41" height="21">
			<rect width="18" height="2" rx="1" />
			<rect y="6" width="18" height="2" rx="1" />
			<rect y="12" width="18" height="2" rx="1" />
		</svg>
	);
}

Hamburger.propTypes = {
	className: PropTypes.string,
};
